import { clone } from "@repo/helpers";
import { MvcLocation, RepFieldAudit } from "@repo/models";
import { useEffect, useRef, useState } from "react";

import { useSettingsApi } from "../../api/settingsApi";
import {
	useLocationContext,
	useRepFieldAuditContext,
	useStatusHistoryContext,
} from "../../contexts/editableItemContext";
import { LocationStatus, Settings } from "../../models";

export default function useTemplateData<TData extends ITemplateData>(otherElements: Partial<TData>) {
	const { useSettingsQuery } = useSettingsApi();
	const { location } = useLocationContext();
	const { item: statusHistory } = useStatusHistoryContext();
	const { item: repFieldAudit } = useRepFieldAuditContext();
	const { data: settings } = useSettingsQuery();
	const templateData = useRef({
		location: clone(location),
		statusHistory: clone(statusHistory),
		repFieldAudit: clone(repFieldAudit),
		settings,
		...otherElements,
	} as TData);
	const [dirty, setDirty] = useState(0);

	useEffect(() => {
		templateData.current = {
			location: clone(location),
			statusHistory: clone(statusHistory),
			repFieldAudit: clone(repFieldAudit),
			settings,
			//user,
			...otherElements,
		} as TData;
		setDirty(dirty + 1);
	}, [location, statusHistory, repFieldAudit, settings, otherElements]);

	return { templateData, dirty };
}

export interface ITemplateData {
	settings: Settings;
	location: MvcLocation;
	statusHistory: LocationStatus;
	repFieldAudit: RepFieldAudit;
	loaded: boolean;
}
